export const isBusinessEmail = (email) => {
    const genericDomains = [
      "gmail.com",
      "yahoo.com",
      "hotmail.com",
      "outlook.com",
      "aol.com",
      "icloud.com",
      "live.com",
      "msn.com",
      "protonmail.com",
      "zoho.com",
      "gmx.com",
      "maildrop.com",
      "mailinator.com"
    ];
  
    const domain = email.split("@")[1]?.toLowerCase();
    return domain && !genericDomains.includes(domain);
  }